import { Paginated } from "../../../../common/domain/models/paginated_models";
import { DiarioObrasAtividadesFilter } from "../../domain/models/diario_obras_atividades_filter";
import { DiarioObrasAtividadesLista } from "../../domain/models/diario_obras_atividades_lista";
import { DiarioObrasEfetivoFilter } from "../../domain/models/diario_obras_efetivo_filter";
import { DiarioObrasEfetivoLista } from "../../domain/models/diario_obras_efetivo_lista";
import { DiarioObrasEquipamentoFilter } from "../../domain/models/diario_obras_equipamento_filter";
import { DiarioObrasEquipamentoLista } from "../../domain/models/diario_obras_equipamento_lista";
import { DiarioObrasFilter } from "../../domain/models/diario_obras_filter";
import { DiarioObrasImagensFilter } from "../../domain/models/diario_obras_imagens_filter";
import { DiarioObrasImagem } from "../../domain/models/diario_obras_imagens_lista";
import { DiarioObrasLista } from "../../domain/models/diario_obras_lista";
import { DiarioObrasParalisacoesFilter } from "../../domain/models/diario_obras_paralisacoes_filter";
import { DiarioObrasParalisacoesLista } from "../../domain/models/diario_obras_paralisacoes_lista";
import { DiarioObrasIndicadores } from "../../domain/models/diarioobras_indicadores_lista";
import { IDiarioObraRepository } from "../../domain/repositories/diario_obra_repository";
import { CreateDiarioObrasResponse } from "../daos/create/create_diario_obra";
import { IDiarioObraService } from "../services/diario_obra_service";

export class DiarioObraRepository implements IDiarioObraRepository {
  constructor(private readonly service: IDiarioObraService) { }
  async getAllListagemDiariosObras(
    filter: DiarioObrasFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<DiarioObrasLista>> {
    const response = await this.service.getAllListagemDiariosObras({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DiarioObrasLista => ({
          IdCentroCusto: item.idCentroCusto,
          Cliente: item.cliente,
          CondicaoTempo: item.condicaoTempo,
          DataAlteracao: item.dataAlteracao,
          DiaPraticavel: item.diaPraticavel,
          DataCadastro: item.dataCadastro,
          AprovadoPor: item.aprovadoPor,
          ResponsavelPor: item.responsavelPor,
          IdDiarioObras: item.idDiarioObras,
          NroDiario: item.nroDiario,
          FuncionariosProprio: item.funcionariosProprio,
          FuncionariosTerceirizados: item.funcionariosTerceirizados,
          NomeCentroCusto: item.nomeCentroCusto,
          DataHora: item.dataHora,
          InicioPrevisto: item.inicioPrevisto,
          Observacao: item.observacao,
          IdCliente: item.idCliente,
          Status: item.status === null ? 0 : item.status,
          IdClienteCentroCusto: item.idClienteCentroCusto,
          IdFuncionarioAprovador: item.idFuncionarioAprovador,
          IdFuncionarioResponsavel: item.idFuncionarioResponsavel,
          AssinaturaCliente: item.assinaturaCliente,
          AssinaturaConstrutora: item.assinaturaConstrutora,
          HorasParalisacao: item.horasParalisacao,
          HorarioAlmocoAte: item.horarioAlmocoAte,
          HorarioAlmocoDe: item.horarioAlmocoDe,
          HorarioTrabalhoAte: item.horarioTrabalhoAte,
          HorarioTrabalhoDe: item.horarioTrabalhoDe,
        }),
      ),
    };
  }

  async deleteDiarioObra(IdDiarioObras: number): Promise<void> {
    await this.service.deleteDiarioObra({ IdDiarioObras });
  }

  async createDiarioObra(
    IdCentroCusto: number | null,
    IdCliente: number | null,
    IdClienteCentroCusto: number | null,
    IdFuncionarioResponsavel: number | null,
    IdFuncionarioAprovador: number | null,
    NumeroDocumento: string | null,
    DataCadastro: Date | null,
    ResponsavelPor: string | null,
    AprovadoPor: string | null,
    CondicaoTempo: string | null,
    DiaPraticavel: number | null,
    Observacao: string | null,
    Status: number | null,
    JustificativaDia: string | null,
    AssinaturaCliente: string | null,
    AssinaturaConstrutora: string | null,
    NroDiario: number | null,
    DataAlteracao: Date | null,
    HorarioTrabalhoDe: string | null,
    HorarioTrabalhoAte: string | null,
    HorarioAlmocoDe: string | null,
    HorarioAlmocoAte: string | null,
  ): Promise<CreateDiarioObrasResponse> {
    const response = await this.service.createDiarioObra({
      IdCentroCusto,
      IdCliente,
      IdClienteCentroCusto,
      IdFuncionarioResponsavel,
      IdFuncionarioAprovador,
      NumeroDocumento,
      DataCadastro,
      ResponsavelPor,
      AprovadoPor,
      CondicaoTempo,
      DiaPraticavel,
      Observacao,
      Status,
      JustificativaDia,
      AssinaturaCliente,
      AssinaturaConstrutora,
      NroDiario,
      DataAlteracao,
      HorarioAlmocoAte,
      HorarioAlmocoDe,
      HorarioTrabalhoAte,
      HorarioTrabalhoDe,
    });
    return response;
  }
  async updateDiarioObra(
    IdDiarioObras: number,
    IdCentroCusto: number | null,
    IdCliente: number | null,
    IdClienteCentroCusto: number | null,
    IdFuncionarioResponsavel: number | null,
    IdFuncionarioAprovador: number | null,
    NumeroDocumento: string | null,
    DataCadastro: Date | null,
    ResponsavelPor: string | null,
    AprovadoPor: string | null,
    CondicaoTempo: string | null,
    DiaPraticavel: number | null,
    Observacao: string | null,
    Status: number | null,
    JustificativaDia: string | null,
    AssinaturaCliente: string | null,
    AssinaturaConstrutora: string | null,
    NroDiario: number | null,
    DataAlteracao: Date | null,
    HorarioTrabalhoDe: string | null,
    HorarioTrabalhoAte: string | null,
    HorarioAlmocoDe: string | null,
    HorarioAlmocoAte: string | null,
  ): Promise<void> {
    await this.service.updateDiarioObra({
      IdDiarioObras,
      IdCentroCusto,
      IdCliente,
      IdClienteCentroCusto,
      IdFuncionarioResponsavel,
      IdFuncionarioAprovador,
      NumeroDocumento,
      DataCadastro,
      ResponsavelPor,
      AprovadoPor,
      CondicaoTempo,
      DiaPraticavel,
      Observacao,
      Status,
      JustificativaDia,
      AssinaturaCliente,
      AssinaturaConstrutora,
      NroDiario,
      DataAlteracao,
      HorarioAlmocoAte,
      HorarioAlmocoDe,
      HorarioTrabalhoAte,
      HorarioTrabalhoDe,
    });
  }
  async copiaDiarioObra(IdDiarioObras: number): Promise<void> {
    await this.service.copiaDiarioObra({ IdDiarioObras });
  }

  async aprovarDiarioObra(
    idFuncionarioAprovador: number,
    diariosObrasIds: number[],
  ): Promise<void> {
    await this.service.aprovarDiarioObra({
      idFuncionarioAprovador,
      diariosObrasIds,
    });
  }

  //#region Efetivo

  async getAllListagemDiariosObrasEfetivo(
    filter: DiarioObrasEfetivoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<DiarioObrasEfetivoLista>> {
    const response = await this.service.getAllListagemDiariosObrasEfetivo({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DiarioObrasEfetivoLista => ({
          IdDiarioObrasEfetivo: item.idDiarioObrasEfetivo,
          IdDiarioObras: item.idDiarioObras,
          IdCargo: item.idCargo,
          IdFornecedor: item.idFornecedor,
          Categoria: item.categoria,
          Descricao: item.descricao,
          NomeCargo: item.nomeCargo,
          NomeFornecedor: item.nomeFornecedor,
          Quantidade: item.quantidade,
          totalGeral: item.totalGeral,
          totalPropria: item.totalPropria,
          totalTerceirizada: item.totalTerceirizada,
          Tipo: item.tipo,
          IdsFuncionarios: item.idsFuncionarios,
        }),
      ),
    };
  }
  async createDiarioObraEfetivo(
    IdDiarioObras: number,
    IdCargo: number | null,
    Tipo: number | null,
    Categoria: number | null,
    Quantidade: number | null,
    Descricao: string | null,
    IdFornecedor: number | null,
    IdsFuncionarios: number[] | null,
  ): Promise<void> {
    await this.service.createDiarioObraEfetivo({
      IdDiarioObras,
      IdCargo,
      Tipo,
      Categoria,
      Quantidade,
      Descricao,
      IdFornecedor,
      IdsFuncionarios,
    });
  }
  async updateDiarioObraEfetivo(
    IdDiarioObras: number,
    IdDiarioObrasEfetivo: number,
    IdCargo: number | null,
    Tipo: number | null,
    Categoria: number | null,
    Quantidade: number | null,
    Descricao: string | null,
    IdFornecedor: number | null,
    IdsFuncionarios: number[] | null,
  ): Promise<void> {
    await this.service.updateDiarioObraEfetivo({
      IdDiarioObras,
      IdDiarioObrasEfetivo,
      IdCargo,
      Tipo,
      Categoria,
      Quantidade,
      Descricao,
      IdFornecedor,
      IdsFuncionarios,
    });
  }
  async deleteDiarioObraEfetivo(
    IdDiarioObras: number,
    IdDiarioObrasEfetivo: number,
  ): Promise<void> {
    await this.service.deleteDiarioObraEfetivo({
      IdDiarioObras,
      IdDiarioObrasEfetivo,
    });
  }
  //#endregion

  //#region Equipamento
  async getAllListagemDiariosObrasEquipamento(
    filter: DiarioObrasEquipamentoFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<DiarioObrasEquipamentoLista>> {
    const response = await this.service.getAllListagemDiariosObrasEquipamento({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DiarioObrasEquipamentoLista => ({
          IdDiarioObrasEquipamento: item.idDiarioObrasEquipamentos,
          IdMaquinaEquip: item.idMaquinaEquip,
          Descricao: item.descricao,
          Quantidade: item.quantidade,
          Tipo: item.tipo,
          IdDiarioObras: item.idDiarioObras,
          NomeMaquinaEquip: item.nomeMaquinaEquip,
        }),
      ),
    };
  }

  async createDiarioObraEquipamento(
    IdDiarioObras: number | null,
    IdMaquinaEquip: number | null,
    Descricao: string | null,
    Tipo: string | null,
    Quantidade: number | null,
  ): Promise<void> {
    await this.service.createDiarioObraEquipamento({
      IdDiarioObras,
      IdMaquinaEquip,
      Descricao,
      Tipo,
      Quantidade,
    });
  }

  async updateDiarioObraEquipamento(
    IdDiarioObrasEquipamentos: number,
    IdDiarioObras: number | null,
    IdMaquinaEquip: number | null,
    Descricao: string | null,
    Tipo: string | null,
    Quantidade: number | null,
  ): Promise<void> {
    await this.service.updateDiarioObraEquipamento({
      IdDiarioObrasEquipamentos,
      IdDiarioObras,
      IdMaquinaEquip,
      Descricao,
      Tipo,
      Quantidade,
    });
  }

  async deleteDiarioObraEquipamento(
    IdDiarioObras: number,
    IdDiarioObrasEquipamentos: number,
  ): Promise<void> {
    await this.service.deleteDiarioObraEquipamento({
      IdDiarioObras,
      IdDiarioObrasEquipamentos,
    });
  }

  //#endregion

  //#region Atividades
  async getAllListagemDiariosObrasAtividades(
    filter: DiarioObrasAtividadesFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<DiarioObrasAtividadesLista>> {
    const response = await this.service.getAllListagemDiariosObrasAtividades({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DiarioObrasAtividadesLista => ({
          IdDiarioObrasAtividades: item.idDiarioObrasAtividades,
          IdDiarioObras: item.idDiarioObras,
          Descricao: item.descricao,
          IdFornecedor: item.idFornecedor,
          Ordem: item.ordem,
          TipoMaoDeObra: item.tipoMaoDeObra,
          NomeFornecedor: item.nomeFornecedor,
        }),
      ),
    };
  }

  async createDiarioObraAtividades(
    IdDiarioObras: number | null,
    Descricao: string | null,
    IdFornecedor: number | null,
    TipoMaoDeObra: number | null,
    Ordem: number | null,
  ): Promise<void> {
    await this.service.createDiarioObraAtividades({
      IdDiarioObras,
      Descricao,
      IdFornecedor,
      TipoMaoDeObra,
      Ordem,
    });
  }
  async updateDiarioObraAtividade(
    IdDiarioObrasAtividades: number,
    IdDiarioObras: number | null,
    Descricao: string | null,
    IdFornecedor: number | null,
    TipoMaoDeObra: number | null,
    Ordem: number | null,
  ): Promise<void> {
    await this.service.updateDiarioObraAtividade({
      IdDiarioObrasAtividades,
      IdDiarioObras,
      Descricao,
      IdFornecedor,
      TipoMaoDeObra,
      Ordem,
    });
  }
  async deleteDiarioObraAtividades(
    IdDiarioObras: number,
    IdDiarioObrasAtividades: number,
  ): Promise<void> {
    await this.service.deleteDiarioObraAtividades({
      IdDiarioObras,
      IdDiarioObrasAtividades,
    });
  }
  //#endregion

  //#region  Paralisacoes
  async getAllListagemDiariosObrasParalisacoes(
    filter: DiarioObrasParalisacoesFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<DiarioObrasParalisacoesLista>> {
    const response = await this.service.getAllListagemDiariosObrasParalisacoes({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DiarioObrasParalisacoesLista => ({
          IdDiarioObrasParalisacoes: item.idDiarioObrasParalisacoes,
          IdDiarioObras: item.idDiarioObras,
          Assunto: item.assunto,
          HorarioFim: item.horarioFim,
          HorarioInicio: item.horarioInicio,
          Motivo: item.motivo,
          TempoParalisacao: item.tempoParalisacao,
        }),
      ),
    };
  }
  async createDiarioObraParalisacoes(
    IdDiarioObras: number | null,
    HorarioInicio: string | null,
    HorarioFim: string | null,
    Motivo: string | null,
    Assunto: string | null,
    TempoParalisacao: string | null,
  ): Promise<void> {
    await this.service.createDiarioObraParalisacoes({
      IdDiarioObras,
      HorarioInicio,
      HorarioFim,
      Motivo,
      Assunto,
      TempoParalisacao,
    });
  }
  async updateDiarioObraParalisacoes(
    IdDiarioObrasParalisacoes: number,
    IdDiarioObras: number | null,
    HorarioInicio: string | null,
    HorarioFim: string | null,
    Motivo: string | null,
    Assunto: string | null,
    TempoParalisacao: string | null,
  ): Promise<void> {
    await this.service.updateDiarioObraParalisacoes({
      IdDiarioObrasParalisacoes: IdDiarioObrasParalisacoes,
      IdDiarioObras,
      HorarioInicio,
      HorarioFim,
      Motivo,
      Assunto,
      TempoParalisacao,
    });
  }
  async deleteDiarioObraParalisacoes(
    IdDiarioObras: number,
    IdDiarioObrasParalisacoes: number,
  ): Promise<void> {
    await this.service.deleteDiarioObraParalisacoes({
      IdDiarioObras,
      IdDiarioObrasParalisacoes: IdDiarioObrasParalisacoes,
    });
  }
  //#endregion

  //#region Imagens
  async getAllListagemDiariosObrasImagens(
    filter: DiarioObrasImagensFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<DiarioObrasImagem>> {
    const response = await this.service.getAllListagemDiariosObrasImagens({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DiarioObrasImagem => ({
          IdDiarioObrasImagens: item.idDiarioObrasImagens,
          IdDiarioObras: item.idDiarioObras,
          DescricaoImagem: item.descricaoImagem,
          ExtensaoImagem: item.extensaoImagem,
          Nome: item.nome,
          Ordem: item.ordem,
        }),
      ),
    };
  }
  async createDiarioObraImagens(
    IdDiarioObras: number | null,
    DescricaoImagem: string | null,
    Imagem: File | null,
    ExtensaoImagem: string | null,
    Nome: string | null,
    Ordem: number | null,
  ): Promise<void> {
    await this.service.createDiarioObraImagens({
      IdDiarioObras,
      DescricaoImagem,
      Imagem,
      ExtensaoImagem,
      Nome,
      Ordem,
    });
  }
  async updateDiarioObraImagens(
    IdDiarioObrasImagens: number,
    IdDiarioObras: number | null,
    DescricaoImagem: string | null,
    Imagem: File | null,
    ExtensaoImagem: string | null,
    Nome: string | null,
    Ordem: number | null,
    LimparArquivo: boolean,
  ): Promise<void> {
    await this.service.updateDiarioObraImagens({
      IdDiarioObrasImagens,
      IdDiarioObras,
      DescricaoImagem,
      Imagem,
      ExtensaoImagem,
      Nome,
      Ordem,
      LimparArquivo,
    });
  }
  async deleteDiarioObraImagens(
    IdDiarioObras: number,
    IdDiarioObrasImagens: number,
  ): Promise<void> {
    await this.service.deleteDiarioObraImagens({
      IdDiarioObras,
      IdDiarioObrasImagens,
    });
  }

  async downloadDiarioObraImagem(idDiarioObrasImagens: number): Promise<Blob> {
    return this.service.downloadDiarioObraArquivoById({ idDiarioObrasImagens });
  }
  //#endregion
  //#region Principal
  async getAllListagemIndicadores(): Promise<DiarioObrasIndicadores> {
    const response = await this.service.getAllListagemIndicadores();
    return response.indicadores;
  }
  //#endregion
}
